import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
    DefaultTitleStrategy,
    type RouterStateSnapshot,
} from '@angular/router';

const DEFAULT_APP_TITLE = 'Quipex';

@Injectable()
export class QuipexTitleStrategy extends DefaultTitleStrategy {
    constructor() {
        super(inject(Title));
    }

    override updateTitle(snapshot: RouterStateSnapshot): void {
        const routeTitle = this.buildTitle(snapshot);
        const title = typeof routeTitle === 'string' ? routeTitle.trim() : '';

        this.title.setTitle(
            title && title.toLowerCase() !== DEFAULT_APP_TITLE.toLowerCase()
                ? `${DEFAULT_APP_TITLE} - ${title}`
                : DEFAULT_APP_TITLE
        );
    }
}
